import { css } from 'styled-components';

import { COLOR_GRAY_30 } from 'styles/variables/colors';

export default css`
  background: white;
  border: 1px solid ${COLOR_GRAY_30};
  border-radius: 4px;
`;
